// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import ElementUI from 'element-ui';
// import VueI18n from 'vue-i18n';
import 'element-ui/lib/theme-chalk/index.css';
// 引入接口
import serverUrl from './js/server-config.js';
// 引入echarts
import * as echarts from 'echarts';
import Ajax from '@/js/ajax.js';
import locale from 'element-ui/lib/locale/lang/en';
Vue.use(ElementUI, { locale });
Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false;
Vue.prototype.Ajax = Ajax;

// 全局api
window.API = serverUrl;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  // i18n,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js